import { initAnalytics } from "@cw-elements/analytics-provider";

// Falls back to this name only for local dev, where REACT_APP_RUM_SERVICE_NAME
// is not set. CI always supplies it (see .circleci/config.yml), sourced from
// the app's registered RUM application name in the Datadog org.
const DATADOG_SERVICE_NAME = "carbon-portal-cropwise-sustainability";

export const initApplicationAnalytics = async () => {
  const amplitudeClientId = process.env.REACT_APP_AMPLITUDE_CLIENT_ID;

  return await initAnalytics({
    ...(amplitudeClientId
      ? { amplitude: { clientId: amplitudeClientId } }
      : {}),
    datadog: {
      applicationId: process.env.REACT_APP_RUM_APPLICATION_ID,
      clientToken: process.env.REACT_APP_RUM_CLIENT_TOKEN,
      site: "datadoghq.eu",
      service: process.env.REACT_APP_RUM_SERVICE_NAME ?? DATADOG_SERVICE_NAME,
      env: process.env.REACT_APP_ENV,
      version: process.env.REACT_APP_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: "mask-user-input",
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      allowedTracingUrls: [process.env.REACT_APP_BASE_API_URL].filter(Boolean),
    },
    consent: { enabled: true },
  });
};
